<template>
  <div
    v-if="showPortrait"
    :class=" isLogin ? 'avatar-btn-no-background' : 'avatar-btn'"
    @click.stop="onAvatarClick"
  >
    <i-avatar
      ref="avatar"
      role="button"
      :url="avatarUrl"
      :login-state="isLogin"
    />
    <span
      v-show="!isLogin && !isMobile()"
      class="avatar-btn-text"
    >{{ $t('general.login') }}</span>
    <ul
      v-show="isDropdownListShow"
      class="dropdown-list"
      :class="dropdownPosition"
    >
      <li
        v-for="item in dropdownList.filter(item => item.group === 'personal')"
        v-show="!item.hidden"
        :key="item.name"
        class="dropdown-list__item"
        @click.stop="onDropdownItemClick(item)"
      >
        <div class="svg-area">
          <svg-icon
            :name="item.name"
            class="svg-icon"
            color="#FFF"
          />
        </div>
        <span>{{ item.text }}</span>
        <span
          v-if="item.isNew"
          class="new-feature"
        >
          {{ $t('general.new') }}
        </span>
      </li>
      <div
        class="menu-group-last-item-line"
      />
      <li
        v-for="item in dropdownList.filter(item => item.group === 'logout')"
        v-show="!item.hidden"
        :key="item.name"
        class="dropdown-list__item"
        @click.stop="onDropdownItemClick(item)"
      >
        <div class="svg-area">
          <svg-icon
            :name="item.name"
            class="svg-icon"
            color="#FFF"
          />
        </div>
        <span>{{ item.text }}</span>
        <span
          v-if="item.isNew"
          class="new-feature"
        >
          {{ $t('general.new') }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { MODALS } from '@/components/VrLounge'
import { mapGetters, mapActions } from 'vuex'
import IAvatar from '@/components/IAvatar'
import SvgIcon from './SvgIcon/index.vue'
import { isMobile } from '../api/utils'
import webStorage from '../store/webStorage/helper'

export default {
  name: 'PortraitIndex',
  components: {
    SvgIcon,
    IAvatar
  },
  props: {
    dropdownPosition: {
      type: String, // 'left' | 'right'
      default: 'left'
    }
  },
  data () {
    return {
      isDropdownListShow: false
    }
  },
  computed: {
    ...mapGetters({
      isLogin: 'auth/isLogin',
      profileUrl: 'auth/profileUrl',
      isFavoritesEnabled: 'favorites/enabled',
      isMoving: 'vrlounge/isMoving',
      currentBuilding: 'currentBuilding',
      portrait: 'auth/portrait'
    }),
    ...mapGetters([
      'currentBuilding',
      'user',
      'isClickAvatar'
    ]),
    avatarUrl () {
      // if (this.portrait && this.portrait.cutUrl) {
      //   return this.portrait.cutUrl
      // }
      return this.profileUrl || ''
    },
    dropdownList () {
      return [
        {
          name: 'person',
          text: this.$t('vrlounge.profile'),
          hidden: !this.isLogin, // or just need to be login
          group: 'personal',
          method: () => this.setCurrentModal(MODALS.update)
        },
        {
          name: 'heart',
          text: this.$t('favorites.title'),
          hidden: !this.isFavoritesEnabled || !this.isLogin,
          group: 'personal',
          method: () => this.showFavoritesDialog()
        },
        {
          name: 'logout',
          text: this.$t('logOut'),
          hidden: !this.isLogin,
          group: 'logout',
          method: () => this.doLogout()
        }
      ]
    },
    isVisitorDataEnable () {
      return this.currentBuilding.requireVisitorData
    },
    isInstantMessagingEnable () {
      return this.currentBuilding.instantMessagingEnable
    },
    showPortrait () {
      return this.isVisitorDataEnable || this.isFavoritesEnabled || this.isInstantMessagingEnable
    }
  },
  watch: {
    async isMoving (val) {
      if (val) {
        this.isDropdownListShow = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.clickHandler)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickHandler)
  },
  methods: {
    isMobile,
    ...mapActions({
      showMobileMenu: 'showMobileMenu',
      logout: 'auth/logout',
      setCurrentModal: 'vrlounge/setCurrentModal',
      changeIsClickAvatarState: 'changeIsClickAvatarState',
      closeFloatMenu: 'closeFloatMenu'
    }),
    ...mapActions('favorites', {
      showFavoritesDialog: 'showDialog',
      destroyFavorites: 'destroy'
    }),
    doLogout () {
      this.$mixpanel.stop()
      this.logout()
      this.destroyFavorites()
      webStorage.removeItem(`session-token-${process.env.NODE_ENV}`)
    },
    clickHandler () {
      if (this.isDropdownListShow) {
        this.isDropdownListShow = false
      }
    },
    onAvatarClick () {
      this.changeIsClickAvatarState(true)
      if (this.isLogin) {
        if (window.innerWidth <= 1024) {
          this.showMobileMenu()
        } else {
          this.isDropdownListShow = !this.isDropdownListShow
        }
      } else {
        this.setCurrentModal(MODALS.login)
      }
      this.closeFloatMenu()
    },
    onDropdownItemClick (item) {
      this.isDropdownListShow = false
      item.method()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/common/main'

.menu-group-last-item-line{
  display: block;
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.16);
  padding: 0;
  margin: 16px 0;
}

.svg-area{
  padding: 8px 12px 8px 0px;
}

.avatar-btn {
  display: flex !important;
  align-items: center;
  padding: 6px;
  border-radius: 24px;
  background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

@media (max-width: 1024px) {
  .avatar-btn {
    padding: 4px;
    background-color: rgba(0, 0, 0, 0.12);
  }
}

.avatar-btn-no-background{
  display: flex !important;
  align-items: center;
  border-radius: 24px;
  cursor: pointer;
  background-color: unset;
}

.avatar-btn:hover{
  background-color: rgba(0, 0, 0, 0.4);
}

.avatar-btn-text{
  margin-left: 8px;
  margin-right: 14px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  text-shadow: none;
}

.dropdown-list {
  position: absolute
  top: 30px
  background-color: #4C4C4C
  color: #FFF
  width: 280px
  padding: 16px 0px 24px 0px
  border-radius: 10px
  .dropdown-list__item {
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 4px 16px
    cursor: pointer
    &:hover {
      background: rgba(255, 255, 255, 0.10);
    }
  }
  &.left {
    right: 100%
  }
  &.right {
    left: 100%
  }
}

.new-feature {
  color: $pink-color
  text-shadow: none
  display: inline
  font-size: 14px;
}
</style>
